/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
export const ListUsersSortField = core.serialization.enum_([
    "email",
    "name",
    "id",
    "idp",
    "idp_ref",
    "created_at",
    "updated_at",
    "last_seen_at",
    "dashboard",
]);
